import React, { useCallback, useEffect, useState } from "react";
import { Modal, Box, Typography, TextField, Button, Divider, IconButton } from "@mui/material";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import { useAuth } from "../../contexts/AuthContext";
import { useProfile } from "../../contexts/ProfileContext";
import config from "../../config";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import { FaApple, FaFacebook, FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { FcGoogle } from "react-icons/fc";

import { signInWithPopup, OAuthProvider } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { auth } from "../../helpers/firebaseConfig";
import AppleLogin from "react-apple-login";
import { Spinner } from "reactstrap";
import { Input } from "antd";
import { showErrorToast, showSuccessToast } from "../../pages/utils";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
// const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
const FACEBOOK_APP_ID = "820738510229807";

const SignInRegister = ({ open, handleClose, setIsLogin }) => {
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isRememberMe, setIsRememberMe] = useState(true);
    const [otpScreen, setOtpScreen] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [otp, setOtp] = React.useState("");
    const navigate = useNavigate();
    const { loginUserSuccess, registerUserSuccess, clearError } = useAuth();
    const { fetchProfile } = useProfile();

    let newUserPayload = {
        first_name: "NA",
        role: "",
        last_name: "NA",
        email: "",
        phone: "",
        facebook: "",
        google: "",
        gmail: "",
        linkedin: "",
        password: "",
    };

    const registerApi = async (info) => {
        setLoading(true);
        setErrorMsg(null);
        const requestUrl = `${config.get("API_URL")}/user/register`;

        try {
            const response = await fetch(requestUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ ...newUserPayload, ...info }),
            });

            if (!response.ok) {
                const errorResponse = await response.json();
                // Error handling moved to context
                showErrorToast(`Registration Failed: ${errorResponse?.detail}`, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
                return;
                // throw new Error("Network response was not ok: " + errorResponse.error);
            }

            const data = await response.json();

            if (data.message) {
                sessionStorage.setItem("userInfo", JSON.stringify(data));
                setOtpScreen(true);
                // Register handling moved to context
            } else {
                if (data.error) {
                    throw new Error(data.error);
                }
                setErrorMsg("Registration failed: No success message received");
                throw new Error("Registration failed: No success message received");
            }
        } catch (error) {
            showErrorToast(error.error || "Registration failed due to an unexpected error.");
            console.error("Registration error:", error);
            setErrorMsg(error.error || "Registration failed due to an unexpected error.");
            setErrorMsg(error.message || "Registration failed due to an unexpected error.");
        } finally {
            setLoading(false);
        }
    };

    const loginApi = async (payload) => {
        const response = await fetch(`${config.get("API_URL")}/user/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            const errorData = await response.json(); // Parse the JSON error response
            const errorMessage = errorData.detail || response.statusText; // Get the actual error message
            if (errorMessage === "User does not exist, please register the user!") {
                registerApi(payload);
            } else {
                showErrorToast(errorMessage, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            }

            setErrorMsg(errorMessage);
            setLoading(false);
            if (errorMessage === "Verify user to login! OTP has been sent to your email.") {
                setOtpScreen(true);
            }
            return;
        } else {
            const data = await response.json();
            if (data.detail) {
                showErrorToast(data.detail);
                setErrorMsg(data.detail);
            } else if (data.access_token) {
                showSuccessToast("Login successful", {
                    autoClose: 3000,
                    pauseOnHover: false,
                });

                // Store tokens in localStorage
                localStorage.setItem("authUser", JSON.stringify(data.access_token));
                localStorage.setItem("refreshToken", JSON.stringify(data.refresh_token));

                // Update AuthContext with login success
                loginUserSuccess({
                    user: data.user || {},
                    token: data.access_token,
                });

                // Fetch fresh profile data
                await fetchProfile();

                setIsLogin(true);
                handleClose();
            }
        }
    };

    const loginWithGoogle = async (userData) => {
        try {
            const payload = {
                email: userData.email,
                google: userData.sub,
                first_name: userData?.name.split(" ")[0],
                last_name: userData?.name.split(" ")[1] || "",
                facebook: userData?.id,
            };
            await loginApi(payload);
        } catch (error) {
            console.error("Google login error:", error);
        }
    };
    const onGoogleButtonPress = useGoogleLogin({
        onSuccess: async (response) => {
            // Get the access token from the response
            const accessToken = response.access_token;

            try {
                // Fetch user information using the access token
                const userInfoResponse = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                loginWithGoogle(userInfoResponse);
                // Handle the user information (e.g., save it in state or send it to your backend)
                // Example user info fields: userInfo.name, userInfo.email, userInfo.picture
            } catch (error) {
                console.error("Failed to fetch user info", error);
                showErrorToast("Failed to fetch user info", {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            }
        },
        onError: (error) => {
            console.error("Google login failed", error);
            showErrorToast("Google login failed, please try again.", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            setErrorMsg("Google login failed, please try again.", {
                autoClose: 3000,
                pauseOnHover: false,
            });
        },
    });

    const responseFacebook = (response) => {
        if (!window.FB) {
            showErrorToast("Facebook login failed, please try again.", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            setErrorMsg("Facebook login failed, please try again.");
            return;
        }
        if (response.accessToken) {
            fetch(`https://graph.facebook.com/me?access_token=${response.accessToken}&fields=name,email,picture`)
                .then((res) => res.json())
                .then((userData) => {
                    const payload = {
                        email: userData.email,
                        facebook: userData?.id,
                    };
                    loginApi(payload);
                })
                .catch((error) => {
                    console.error("Error fetching user data:", error);
                });
        } else {
            showErrorToast("Facebook login failed, please try again.", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            setErrorMsg("Facebook login failed, please try again.");
        }
    };
    const handleLogin = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            showErrorToast("Please enter both email and password", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            setErrorMsg("Please enter email and password");
            return;
        }
        setLoading(true);
        setErrorMsg("");

        try {
            await loginApi({ email, password });
        } catch (error) {
            showErrorToast(error.message || "Invalid email or password", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            setErrorMsg(error.message || "Invalid email or password", {
                autoClose: 3000,
                pauseOnHover: false,
            });
        } finally {
            setLoading(false);
        }
    };

    const handleOtpVerification = async () => {
        if (!otp) {
            showErrorToast("Please enter OTP", { autoClose: 3000, pauseOnHover: false });
            return;
        } else {
            setLoading(true);
            setErrorMsg("");

            const requestUrl = `${config.get("API_URL")}/user/verify-otp`;
            const postData = {
                email,
                code: otp,
                purpose: "verification",
            };

            try {
                const response = await fetch(requestUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(postData),
                });

                if (!response.ok) {
                    const errorResponse = await response.json(); // Assuming the server sends a JSON response for errors
                    showErrorToast(errorResponse.message || errorResponse.error, {
                        autoClose: 3000,
                        pauseOnHover: false,
                    });
                    handleClose();
                    setOtpScreen(false);
                } else {
                    const data = await response.json();

                    if (data.message === "OTP verification successful") {
                        showSuccessToast(data.message, {
                            autoClose: 3000,
                            pauseOnHover: false,
                        });

                        // Store tokens in localStorage
                        localStorage.setItem("authUser", JSON.stringify(data.access_token));
                        localStorage.setItem("refreshToken", JSON.stringify(data.refresh_token));

                        // Update AuthContext with login success (this is from OTP verification)
                        loginUserSuccess({
                            user: data.user || {},
                            token: data.access_token,
                        });

                        // Fetch fresh profile data
                        await fetchProfile();

                        setIsLogin(true);
                        handleClose();
                    } else {
                        throw new Error(data.message || "Verification failed: No success message received");
                    }
                }
            } catch (error) {
                console.error("Verification error:", error);
                setErrorMsg(error.message || "Verification failed. Please try again.");
            } finally {
                setLoading(false);
            }
        }
    };
    const onInput = (value) => {};

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                className="tw-bg-white tw-shadow-lg tw-rounded-lg tw-p-8"
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                {!otpScreen ? (
                    <>
                        <Typography variant="h6" className="tw-text-center tw-mb-4">
                            Please Sign In Or Register To use our services
                        </Typography>
                        <form onSubmit={handleLogin}>
                            <div className="tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                <TextField
                                    fullWidth
                                    label="Email"
                                    type="email"
                                    value={email}
                                    required
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter Email"
                                    variant="outlined"
                                    margin="normal"
                                />
                            </div>
                            <div className=" tw-w-full tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                <div className="tw-relative ">
                                    {/* <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                required
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Password"
                                className="tw-px-3 tw-bg-background_color max-sm:tw-bg-transparent tw-w-full tw-placeholder-placeholder_color tw-outline-none tw-rounded-[10px] md:tw-h-[50px] max-sm:tw-h-[40px]  tw-border tw-border-border_color 2xl:tw-text-[22px]"
                            /> */}
                                    <TextField
                                        fullWidth
                                        label="Password"
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        required
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Enter password"
                                        variant="outlined"
                                        margin="normal"
                                    />
                                    {/* Toggle Button */}
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword((prev) => !prev)}
                                        className="tw-absolute tw-right-3 tw-top-9 max-sm:tw-top-3"
                                    >
                                        {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                                    </button>
                                </div>
                            </div>
                            {/* <TextField fullWidth label="Email" placeholder="Enter Email" variant="outlined" margin="normal" />
                    <TextField fullWidth label="Password" placeholder="Enter password" type="password" variant="outlined" margin="normal" /> */}
                            <button
                                // onClick={handleLogin}
                                type="submit"
                                className=" tw-bg-primary tw-w-full hover:tw-bg-primary_hover tw-border-none tw-text-white tw-mt-5 tw-p-3 tw-rounded-[9px] 2xl:tw-text-[22px]"
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={24} color="inherit" /> : "Log In"}
                            </button>
                        </form>
                        <Divider className="tw-my-4">Or continue with</Divider>
                        <Box className="tw-flex tw-justify-center tw-gap-2">
                            <div className="tw-w-full tw-flex tw-justify-center">
                                <div className="tw-flex max-sm:tw-w-fit tw-text-[8px] md:tw-text-[14px] tw-gap-5  tw-text-black tw-items-center tw-text-center tw-justify-center ">
                                    <AppleLogin
                                        clientId="admin.airebrokers.com"
                                        // clientId="DKWYR2P277.com.airebrokers"
                                        redirectURI="https://admin.airebrokers.com/login"
                                        usePopup={true}
                                        // callback={this.appleResponse} // Catch the response
                                        scope="email name"
                                        responseMode="query"
                                        render={(renderProps) => (
                                            <button
                                                // onClick={loginWithApple}
                                                onClick={renderProps.onClick}
                                                className="tw-bg-icon_background  tw-w-fit tw-justify-center tw-p-2 max-sm:tw-w-full tw-rounded-full tw-flex md:tw-gap-2 tw-items-center"
                                            >
                                                <FaApple className="tw-text-[20px] max-sm:tw-text-[15px] tw-object-contain" />
                                            </button>
                                        )}
                                    />
                                    <button
                                        onClick={onGoogleButtonPress}
                                        className="tw-bg-icon_background  tw-w-fit tw-justify-center tw-p-2  max-sm:tw-w-full tw-rounded-full tw-flex md:tw-gap-2 tw-items-center"
                                    >
                                        <FcGoogle className="tw-text-[20px] max-sm:tw-text-[15px] tw-object-contain" />
                                    </button>
                                    <FacebookLogin
                                        appId={FACEBOOK_APP_ID}
                                        autoLoad={false}
                                        scope="public_profile,email"
                                        callback={responseFacebook}
                                        render={(renderProps) => (
                                            <button
                                                onClick={renderProps.onClick}
                                                className="tw-bg-icon_background  tw-w-fit tw-justify-center tw-p-2 max-sm:tw-w-full tw-rounded-full tw-flex md:tw-gap-2 tw-items-center"
                                            >
                                                <FaFacebook className="tw-text-[20px] max-sm:tw-text-[15px] tw-text-blue-500 tw-object-contain" />
                                            </button>
                                        )}
                                    />
                                </div>
                            </div>
                        </Box>
                    </>
                ) : (
                    <>
                        <div className="tw-flex tw-flex-col tw-gap-2  2xl:tw-gap-5 ">
                            <div className=" tw-flex tw-flex-col tw-gap-[10px]">
                                <Typography variant="h6" className="tw-text-center tw-mb-4">
                                    Enter Verification Code{" "}
                                </Typography>
                                <p className="tw-text-[16px] tw-text-center 2xl:tw-text-[20px] md:tw-text-semi_dark_text max-sm:tw-font-thin">
                                    Enter your 6 digits code that you received on your email.
                                </p>
                            </div>

                            <div className="tw-mt-5 tw-flex tw-flex-col tw-items-center">
                                <div className="tw-max-w-[250px] tw-h-[55px] tw-w-full tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3">
                                    {/* <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">Enter OTP</span> */}
                                    <Input.OTP length={6} size="large" className="tw-h-full" onChange={(val) => setOtp(val)} onInput={onInput} />
                                </div>
                                <div className="tw-flex tw-flex-col">
                                    <button
                                        onClick={handleOtpVerification}
                                        className="tw-bg-primary tw-border-none tw-text-white tw-mt-5 tw-p-3 tw-px-10 tw-rounded-md 2xl:tw-text-[18px]"
                                        disabled={loading ? true : false}
                                    >
                                        {loading ? <Spinner size="sm" color="light" /> : "Verify"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </Box>
        </Modal>
    );
};

export default SignInRegister;
